const Input = ({ label, span, ...props }) => {
  return (
    <div className={`flex flex-col gap-1 ${span ? "md:col-span-2" : ""}`}>
      {label && <label className="text-sm font-semibold">{label}</label>}

      <input
        {...props}
        className="border rounded-xl px-3 py-2"
      />
    </div>
  );
};


export default Input;
